
import { Component, Vue, Watch } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import StepsEnterprise from '../StepsEnterprise.vue'
import http from '@/utils/request'
import '../register.scss'
import Loading from '../Loading.vue'
import { sleep } from '@/utils'
import i18n from '@/lang'

@Component({
  components: { StepsEnterprise, Loading }
})
export default class Platform extends Vue {
  private registerFormRef!: ElForm
  private submitLoading = false
  private submitDisabled = true
  private showLoading = false
  private loadingStatus = ''

  private form = {
    privyId: '',
    accountNumber: '',
    accountName: ''
  }

  testForm() {
    this.form.privyId = 'WORLD'
    this.form.accountNumber = '2342084029348'
    this.form.accountName = 'LJKLJ'
  }

  private rules = {}

  @Watch('form', { deep: true })
  onFormChange() {
    // eslint-disable-next-line
    const { ...params } = this.form
    const valid = Object.values(params).every(
      value => value !== '' && value !== undefined && value !== null
    )
    this.submitDisabled = !valid
  }

  async onSubmit() {
    try {
      await this.registerFormRef.validate()

      this.submitLoading = true
      this.showLoading = true

      const params = { ...this.form }

      await sleep(500)
      const data = await http.post('/lend/api/updateLend', params)
      if (data) {
        this.loadingStatus = 'success'
        await sleep(1500)
        // After successful registration, log in
        await this.$router.push({ path: '/register/supplementary' })
      } else {
        this.$notify.error({ title: i18n.t('Registration failed') as string, message: '' })
      }
    } catch (e) {
      // handle error
    } finally {
      this.submitLoading = false
      this.showLoading = false
    }
  }

  mounted() {
    this.registerFormRef = this.$refs.registerFormRef as ElForm
    if (process.env.NODE_ENV === 'development') {
      this.testForm()
    }
  }
}
